/** @format */

import { Fragment, useEffect } from "react";
import { logger } from "@goldenbird1/ui-logger-library";
import Head from "next/head";
import { useRouter } from "next/router";
// import { useKeycloak } from "@react-keycloak/ssr";
import cookie from "js-cookie";
import store from "../../store";
import { useCookies } from "react-cookie";
import {
  setAuth,
  setUserProfile,
  getUserProfile,
  setUserProfileLoading,
} from "../../store/actions";
import { loginEvent } from "../../utils/GTMDataLayer";
import { accessToken } from "../../utils/accessToken";

export const Layout = ({ children, meta = {}, isShowRibbon }) => {
  const router = useRouter();
  const title = meta?.title || "";
  const description = meta?.description || "";
  const keywords = meta?.keywords || "";
  const [cookies, setCookie, removeCookie] = useCookies(["utm_source"]);

  let token = "";
  useEffect(() => {
    console.log('I got called');
    token = accessToken();
    if(!token){
      console.log('m called from layout js');
      // router.push('/signin');
    }
  }, []); 

  useEffect(() => {
    if (/Android 4\.[0-3]/.test(navigator.appVersion)) {
      // console.log("m in modal");
      window.addEventListener("resize", function () {
        if (
          document.activeElement.tagName == "input" ||
          document.activeElement.tagName == "TEXTAREA"
        ) {
          document?.activeElement?.scrollIntoView({"block": "center"})
        }
      });
    }

    // keep track of user path to route back to it inCase of sign-up completion
    if(router.pathname && !router.asPath.includes("utm")){
      console.log('router', router.asPath)
      let routesToIgnore = ['/signin/', '/signup/', '/forgotpassword/'];
      if(!router.asPath.includes('session_state')){
      if(!routesToIgnore.includes(router.asPath) && router.asPath.split('/')[1] !== 'resetpassword'){
        localStorage.setItem('pathname', router.asPath)
      }
    }
    }
  }, []);

  // const { keycloak } = useKeycloak();

  // let retryUserProfile = 0;
  // const retryProfile = (access_token) => {
  //   if(retryUserProfile < 3){
  //     store.dispatch(getUserProfile(access_token, (result) => {
  //       let { error = false } = result;
  //       if(error){
  //         retryProfile();
  //       }
  //     }));
  //   } else {
  //     store.dispatch(setAuth(access_token, null));
  //     logger("error", "Error while loading userProfile while login/signin:", process.env.NEXT_PUBLIC_LOGGER_URL);
  //   }
  //   retryUserProfile++;
  // }

  // useEffect(() => {
  //   if (keycloak?.token) {
  //     // console.log("Layout ", keycloak.token);
  //     if(!localStorage.getItem("userProfile")){
  //       keycloak
  //         .loadUserProfile()
  //         .then((profile) => {
  //           if (!cookie.get("loggedInUser")) {
  //             const { attributes: { profileType = [] } = {} } = profile;
  //             let profileId = profileType[0] || "";
  //             profileId = profileId.replace("BUYER::", "");
  //             profileId = profileId.replace("SELLER::", "");
  //             if (profileId) {
  //               // console.log("Profile id ", profileId);
  //               let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL +
  //                   "/profiles/" +
  //                   profileId +
  //                   "/events/login";
  //               fetch(
  //                 url,
  //                 {
  //                   method: "POST",
  //                   headers: {
  //                     "Content-Type": "application/json",
  //                     Authorization: "Bearer " + keycloak.token,
  //                   },
  //                 }
  //               )
  //                 .then((res) => {
  //                   if (res.ok) {
  //                     cookie.set("loggedInUser", true);
  //                     loginEvent();
  //                     return res.json();
  //                   } else {
  //                     throw res.statusText || "Error while getting user deatils.";
  //                   }
  //                 })
  //                 .then((res) => {
  //                   return true;
  //                 })
  //                 .catch((err) => {
  //                   console.log(err);
  //                   logger("error", "Error while loading userProfile while login/signin:" +err+': url => '+url+': buyerId => '+profileId, process.env.NEXT_PUBLIC_LOGGER_URL);
  //                 });
  //             }
  //           }
  //           localStorage.setItem('loggedInUser',true)
  //           store.dispatch(setAuth(keycloak.authenticated, profile));
  //         })
  //         .catch((error) => {
  //           store.dispatch(setAuth(keycloak.authenticated, null));
  //           logger("error", "Error while loading userProfile while login/signin:" +error, process.env.NEXT_PUBLIC_LOGGER_URL);
  //           // router.push('/error?message="Somthing went wrong on loading user profile."&redirectURI='+router.pathname);
  //         });
  //       store.dispatch(getUserProfile(keycloak.token, (res) => {
  //         let { error = false } = res;
  //         if(error){
  //           retryProfile();
  //         }
  //       }));
  //     }else{
  //       store.dispatch(setUserProfile(JSON.parse(localStorage.getItem("userProfile"))));
  //       store.dispatch(setUserProfileLoading(false));
  //     }
  //     // console.log("In dispatch");
  //     // if(!sessionStorage.getItem("userProfile")){
  //     //   store.dispatch(getUserProfile(keycloak.token, (res) => {
  //     //     let { error = false } = res;
  //     //     if(error){
  //     //       retryProfile();
  //     //     }
  //     //     console.log('res in layout', res);
  //     //   }));
  //     // }else{
  //     //   console.log('sessionStorage.getItem("userProfile")', JSON.parse(sessionStorage.getItem("userProfile")));
  //     //   store.dispatch(setUserProfile(JSON.parse(sessionStorage.getItem("userProfile"))));
  //     //   store.dispatch(setUserProfileLoading(false));
  //     // }
  //   } else {
  //     // console.log("Layout ", keycloak);
  //     store.dispatch(setUserProfileLoading(false));
  //   }
  // }, [keycloak?.token]);

  // useEffect(() => {
  //   if(localStorage.getItem('kcRefreshToken') && !localStorage.getItem("userProfile")){
  //     if(localStorage.getItem("kcTokenSaved")){
  //       let access_token = localStorage.getItem('kcAccessToken');
  //       console.log('m here in layout', store.getState('userProfile'))
  //       store.dispatch(getUserProfile(access_token, (res) => {
  //         let { error = false } = res;
  //         if(error){
  //           retryProfile(access_token);
  //         }
  //         localStorage.setItem('loggedInUser',true);
  //         // store.dispatch(setAuth(true, profile));
  //       }));
  //     }
  //   } else {
  //     store.dispatch(setUserProfileLoading(false));
  //   }
  // }, []);

   const jsonLdData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://www.qalara.com/#organization",
        "name": "Qalara",
        "url": "https://www.qalara.com/",
        "logo": "https://www.qalara.com/qalara_logo_transparent.png",
        "sameAs": [
          "https://www.linkedin.com/company/qalara/",
          "https://www.instagram.com/qalaraglobal/",
          "https://www.facebook.com/QalaraGlobal/",
          "https://www.youtube.com/channel/UCgp3xTumIlHE11xoIM1BCag",
          "https://in.pinterest.com/socialqalara/",
          "https://www.trustpilot.com/review/qalara.com",
          "https://www.crunchbase.com/organization/qalara",
          "https://www.quora.com/profile/Qalara-Global"
        ],
        "description": "A leading global sourcing platform for responsibly produced home & lifestyle products from India.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "40"
        },
        "brand": { "@type": "Brand", "name": "Qalara" },
        "founder": { "@type": "Person", "name": "Aditi Pany" },
        "foundingDate": "2020",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer support",
          "email": "contact@qalara.com",
          "telephone": "+16893992166"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "3rd Floor, Building B, IBC Knowledge Park, Bannerghatta Road",
          "addressLocality": "Bangalore",
          "addressCountry": "IN"
        }
      }
    ]
  };

  

  return (
    <Fragment>
      <Head>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {title && <meta property="og:title" content={title} />}
        {meta?.url && (
          <meta
            property="og:url"
            content={`${process.env.NEXT_PUBLIC_URL}${meta.url}`}
          />
        )}
              {meta?.url ? (
  <link rel="canonical" href={`https://www.qalara.com${meta.url}`} />
) : (
  <link rel="canonical" href={`https://www.qalara.com${router.asPath?.split("?")[0] || "/"}`} />
)}

        <meta property="og:type" content="website" />
        <meta property="og:description" content={description} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="p:domain_verify" content="12cb48e4f9c5a5e93e96d324ee125b4d"/>

        <meta
          name="facebook-domain-verification"
          content="9qp2d31txcxcinin40xrvxha3o1d9q"
        />
        {/* <meta http-equiv="content-type" content="text/html; charset=UTF-8" /> */}
        <meta name="viewport" content="width=device-width,height=device-height,initial-scale=1,shrink-to-fit=no"></meta>
        {/* <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta> */}
        {process.env.NODE_ENV !== "production" && (
          <>
            <meta name="robots" content="noindex" />
            <meta name="googlebot" content="noindex" />
          </>
        )}
       {/* <link
          rel="preload"
          href="https://cdn.qalara.com/images/Img_Homepage_Banner_Qalara1_38.jpg"
        />*/}
        <link
          rel="icon"
          href={`${process.env.NEXT_PUBLIC_REACT_APP_CDN_URL}/images/Img_Favicon_Public.ico`}
        />
       {/* <script
          src={`https://www.paypal.com/sdk/js?client-id=${process.env.NEXT_PUBLIC_REACT_APP_PAYPAL_CLIENT_ID}&currency=USD&intent=order`}
          id="paypal-script"
          type="text/javaScript"
          async
        ></script>*/}
        {/* <link rel="preconnect" href="https://cdn.moengage.com/" crossorigin />
        <link rel="dns-prefetch" href="https://cdn.moengage.com/" />
        <link
          rel="preconnect"
          href="https://sdk-04.moengage.com/"
          crossorigin
        />
        <link rel="dns-prefetch" href="https://sdk-04.moengage.com/" /> */}
        {/* <script src="https://cdn.moengage.com/webpush/moe_webSdk_webp.min.latest.js?app_id=Q8EY62FPKU0N737L4M46S89Q&cluster=DC_4&debug_logs=1"></script> */}
        <meta name="viewport" content="width=device-width, user-scalable=no" />
        {/* ✅ Add JSON-LD structured data here */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdData) }}
        />
      </Head>
      {children}
    </Fragment>
  );
};
